import MarkDownRenderer from '../../../../commonComponents/MarkDownRender/MarkDownRender.Component';

export const markdownContent = `
# 🗂️ How to Create a Workspace

A workspace is the root container for all your collections, flows, and scripts in HawkClient.

---

## ➕ Step 1: Create Workspace

Click on the **+ Workspace** icon on the **right side of the header**.

![Create Workspace](/getting-started/createWorkspace.png)

---

## ✏️ Step 2: Configure Workspace Details

A dialog box will appear asking for:

- **Workspace Name**
- **Directory** (optional)

### 📂 Directory Field Notes
- The **Directory** field is optional
- By default, the workspace is stored under:
  
  \`Documents/hawkClient\`

- **Recommended:** Point the workspace directory to your **GitHub repository**

This allows you to:
- Version control your workspace
- Share collections with teammates
- Collaborate easily using Git

---

## ✅ Done!

Your workspace is now ready.  
You can start creating collections, requests, and API flows.
`;

const CreateWorkspace = () => {
    return (
        <MarkDownRenderer
            title="Create Workspace"
            markDownText={markdownContent}
        />
    );
};

export default CreateWorkspace;
